import type { IKlaviyoStatusResponse } from '../types';

export const getStatus = async (): Promise<IKlaviyoStatusResponse | null> => {
  const currentStatus: IKlaviyoStatusResponse | null = await fetch('https://status.klaviyo.com/api/v2/status.json')
    .then((response) => response.json())
    .then((data) => data ?? null);

  return currentStatus;
};
